import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

/**
 * Clickable column header label showing the current TanStack Table sort
 * direction. Pair `onClick` with `header.column.getToggleSortingHandler()`
 * and `isSorted` with `header.column.getIsSorted()`.
 */
export const SortableHeaderLabel = ({ label, isSorted, onClick }: {
    label: string;
    isSorted: false | 'asc' | 'desc';
    onClick: React.MouseEventHandler | undefined;
}) => (
    <Box
        component="button"
        type="button"
        onClick={onClick}
        sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 0.5,
            minWidth: 0,
            maxWidth: '100%',
            overflow: 'hidden',
            border: 'none',
            background: 'none',
            p: 0,
            cursor: 'pointer',
            font: 'inherit',
            color: isSorted ? 'primary.main' : 'text.secondary',
            fontWeight: 700,
            fontSize: 12,
            textTransform: 'uppercase',
            letterSpacing: 0.4,
        }}
    >
        <Box component="span" sx={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
            {label}
        </Box>
        {isSorted && (
            <Box component="span" sx={{ flexShrink: 0 }}>
                {isSorted === 'asc' ? '▲' : '▼'}
            </Box>
        )}
    </Box>
);

/** Non-sortable column header label, styled to match SortableHeaderLabel. */
export const HeaderLabel = ({ label }: { label: string }) => (
    <Typography noWrap sx={{ fontWeight: 700, fontSize: 12, textTransform: 'uppercase', letterSpacing: 0.4, color: 'text.secondary' }}>
        {label}
    </Typography>
);
